import { useState } from "react";
import { sendTemplateApi } from "../../Services/Template";

export default function TemplatePreview({ template }) {
	const [phones, setPhones] = useState("");
	const [loading, setLoading] = useState(false);

	const header = template.components?.find((c) => c.type === "HEADER");
	const body = template.components?.find((c) => c.type === "BODY");
	const footer = template.components?.find((c) => c.type === "FOOTER");
	const buttons = template.components?.find((c) => c.type === "BUTTONS");

	const sendTemplate = async () => {
		if (!phones.trim()) return;

		const phoneList = phones.split(",").map((p) => p.trim());

		setLoading(true);

		try {
			await sendTemplateApi({
				phones: phoneList,
				templateName: template.name,
				templateText: body?.text || "",
			});

			setPhones("");
		} catch (err) {
			console.error(err);
			alert("Failed to send template");
		} finally {
			setLoading(false);
		}
	};

	return (
		<div className="flex-1 flex flex-col bg-gray-50">
			<div className="flex-1 overflow-y-auto p-6 flex justify-center">
				<div className="w-full max-w-xl bg-white rounded-xl shadow-sm border p-5 space-y-4">
					{header && (
						<div className="text-lg font-semibold text-gray-800">
							{header.text}
						</div>
					)}

					{body && (
						<div className="text-sm text-gray-600 whitespace-pre-line">
							{body.text}
						</div>
					)}

					{buttons && (
						<div className="pt-3 border-t flex flex-col gap-2">
							{buttons.buttons.map((btn, i) => (
								<a
									key={i}
									href={btn.url}
									target="_blank"
									rel="noreferrer"
									className="text-sm text-[#0b5cff] hover:underline"
								>
									🔗 {btn.text}
								</a>
							))}
						</div>
					)}

					{footer && (
						<div className="text-xs text-gray-400 border-t pt-2">
							{footer.text}
						</div>
					)}
				</div>
			</div>

			<div className="bg-white border-t p-4 flex gap-3">
				<input
					value={phones}
					onChange={(e) => setPhones(e.target.value)}
					placeholder="Enter phone numbers (comma separated)"
					className="flex-1 px-4 py-2 border rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-[#0b5cff]/30"
				/>

				<button
					onClick={sendTemplate}
					disabled={loading}
					className="bg-[#0b5cff] text-white px-5 py-2 rounded-lg text-sm font-medium disabled:opacity-50"
				>
					{loading ? "Sending..." : "Send"}
				</button>
			</div>
		</div>
	);
}
